<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1 class="display-3  text-white">Data Augmentation
                                </h1>
                                <p class="lead  text-white">
                                    Machine learning requires a large amount of data to train AI models, and the more sufficient the amount of data, the better the effect of the trained model; but in actual enterprise production, it is difficult for many projects to complete the training of the intelligent model with sufficient data. Augmentation is a very effective method to expand data samples. Relying on the company's technology, we have developed a complete set of data agumentation solutions, establishing separated augmentation models for different types of data such as text, image, video, and voice, and providing diversified data augmentation methods.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        
        <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-map-big" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Customization</h6>
                                    <p class="description mt-3">Understand the customer’s data types and characteristics, and formulate appropriate data enhancement programs based on the data types and characteristics.</p>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-basket" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase">Diversification</h6>
                                    <p class="description mt-3">Provide independent data enhancement methods for different types of data to ensure the diversity of data enhancement and the consistency of data generation.</p>  
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-support-16" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">Automation</h6>
                                    <p class="description mt-3">We have built a set of automated data augmentation programs, using a unified project configuration to achieve automated data augmentation processing.</p>    
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Service Features</h2>
                    </div>
                </div>
            <div class="container">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-6">
                            <card shadow class="shadow-lg--hover mt-5">
                                <h5 class="title text-success">Diversified data types</h5>
                                <p>Augment diversified data such as text, audio, image and video, and develop an independent augmentation engine for each type of data.</p>
                            </card>
                        </div>
                        <div class="col-lg-6">    
                            <card shadow class="shadow-lg--hover mt-5">
                                <h5 class="title text-primary">Rich augmentation tools</h5>
                                <p>For each type of data, a wealth of data augmentation tools are integrated to meet the different data augmentation needs of customers.</p>
                            </card>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-6">
                            <card shadow class="shadow-lg--hover mt-5">
                                <h5 class="title text-warning">Automated enhancement processing</h5>
                                <p>Through the detail configuration file, we provide one-click automatic processing to fulfill user's data augmentation tasks.</p>
                            </card>
                        </div>    
                        <div class="col-lg-6">    
                            <card shadow class="shadow-lg--hover mt-5">
                                <h5 class="title text-dafault">Flexible augmentation strategy</h5>
                                <p>Flexible configuration for data augmentation strategy, flexible control of the output style and format of processed data.</p>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
            
        </section>

        <section class="section section-shaped section-lg my-0">
            <div class="shape shape-style-1 bg-gradient-default">
                <span class="span-150"></span>
                <span class="span-50"></span>
                <span class="span-50"></span>
                <span class="span-75"></span>
                <span class="span-100"></span>
            </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">Interested in data augmentation service?</h4>
                            <p class="mt-0">Your feedback is very important to us.</p>
                            <base-input class="mt-5"
                                        alternative
                                        placeholder="Your name"
                                        v-model="form.name"
                                        addon-left-icon="ni ni-single-02">
                            </base-input>
                            <base-input alternative
                                        placeholder="Email address"
                                        v-model="form.email"
                                        addon-left-icon="ni ni-email-83">
                            </base-input>
                            <base-input alternative
                                        placeholder="Phone number"
                                        v-model="form.phone"
                                        @input="phoneNumber"
                                        addon-left-icon="ni ni-mobile-button">
                            </base-input>
                            <base-input alternative
                                        placeholder="Company name"
                                        v-model="form.company"
                                        addon-left-icon="ni ni-building">
                            </base-input>
                            <base-input class="mb-4">
                                <textarea 
                                    class="form-control form-control-alternative" 
                                    name="name"
                                    rows="4"
                                    cols="80" 
                                    placeholder="Type a message..."
                                    v-model="form.message">
                                </textarea>
                            </base-input>
                             <small class="text-light">{{indicator}}</small>
                            <base-button type="primary" round block @click="sendMessage">
                                Send Message
                            </base-button>
                        </card>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
import axios from 'axios'
import Tabs from '@/components/Tabs/Tabs';
import TabPane from '@/components/Tabs/TabPane';
export default {
    name: "data-augmentation",
    components: {
        Tabs,
        TabPane
    },
    data() {
        return {
        form: {
            name: '',
            email: '',
            phone: '',
            company: '',
            message: ''
        },
        interest_string: '0000000001',
        indicator:''
        };
    },
    methods: {
        isValidateEmail: function() {
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(this.form.email);
        },
        isValidatePhone: function() {
            if (this.form.phone != "") {
                return this.form.phone.match(/\d/g).length===10;
            }
            return false;
        },
        phoneNumber() {
            var x = this.form.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.form.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        async sendMessage(){
            this.indicator = "Sending message..."
            if (this.form.name === "") {
                this.indicator = "Please input your name!"
                return
            }
            if (this.isValidateEmail() === false) {
                this.indicator = "Please input a valid email address!"
                return
            }
            if (this.isValidatePhone() === false) {
                this.indicator = "Please input a valid phone number!"
                return
            }
            if (this.form.company === "") {
                this.indicator = "Please input your company name!"
                return
            }
            if (this.form.message === "") {
                this.indicator = "Please input your message!"
                return
            }
        
            axios.post('/feedback', {
                'Name': this.form.name,
                'Phone': this.form.phone,
                'Email': this.form.email,
                'Company': this.form.company,
                'Interest': this.interest_string,
                'Message': this.form.message
            })
            .then((response) => {
            
                if (response.status === 200 && response.data != null) {
                switch (response.data.code){
                    case 200:
                        this.indicator = "We have received your message and will contact you as soon as possible！"
                        this.form.name = ""
                        this.form.company = ""
                        this.form.email = ""
                        this.form.phone = ""
                        this.form.message = ""
                        break
                    default:
                        this.indicator = "Sever error, please try again later！"
                }
                }
            })
            .catch( error => {
                this.indicator = "Sever error, please try again later！"
            })
        }	
    }
};
</script>